let cachedTelegramInitData = '';

export function getTelegramInitData() {
    const sdkValue = window.Telegram?.WebApp?.initData;
    if (typeof sdkValue === 'string' && sdkValue.trim()) {
        cachedTelegramInitData = sdkValue.trim();
        return cachedTelegramInitData;
    }

    // On some iOS Telegram WebViews the SDK object is initialised later than
    // the application bundle, while the signed launch payload is already in
    // the URL fragment. Pass that same signed value to the backend; the client
    // never decides whether it is trustworthy.
    for (const rawParams of [window.location.hash.slice(1), window.location.search.slice(1)]) {
        if (!rawParams) continue;
        const value = new URLSearchParams(rawParams).get('tgWebAppData');
        if (value?.trim()) {
            cachedTelegramInitData = value.trim();
            return cachedTelegramInitData;
        }
    }

    // Telegram iOS/Android can clear the SDK fields when an existing WebView
    // is restored. Keep only the signed launch value captured in this JS
    // context; the backend still validates its signature and age.
    return cachedTelegramInitData;
}

export function getTelegramLaunchUser(initData = getTelegramInitData()) {
    const sdkUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
    if (sdkUser?.id) return sdkUser;
    if (!initData) return null;

    try {
        const serializedUser = new URLSearchParams(initData).get('user');
        const user = serializedUser ? JSON.parse(serializedUser) : null;
        return user?.id ? user : null;
    } catch {
        return null;
    }
}
